var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageLoader'),_c('Featured',{staticClass:"spacer"}),_c('About',{staticClass:"spacer-s"}),_c('Contact',{staticClass:"spacer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }